var map = {
	"./NS_logo.png": 78011,
	"./SPIT_logo.png": 98774,
	"./bg-input-focus.png": 44121,
	"./bg-input.png": 24938,
	"./dark.png": 87936,
	"./data_science.jpg": 65355,
	"./flags.png": 10075,
	"./flags@2x.png": 93157,
	"./foobg.png": 89383,
	"./logo.png": 48801,
	"./sort_asc.png": 39122,
	"./sort_asc_disabled.png": 14135,
	"./sort_both.png": 22140,
	"./sort_desc.png": 22846,
	"./sort_desc_disabled.png": 47107,
	"./spit_colon.png": 41962,
	"./spit_crohns.png": 37512,
	"./spit_oes.png": 36800,
	"./sprite.png": 28875,
	"./ts_icon.png": 95271,
	"./wink.png": 90781,
	"./wink.svg": 19202,
	"./wood.png": 17367,
	"NS_logo.png": 78011,
	"SPIT_logo.png": 98774,
	"bg-input-focus.png": 44121,
	"bg-input.png": 24938,
	"dark.png": 87936,
	"data_science.jpg": 65355,
	"flags.png": 10075,
	"flags@2x.png": 93157,
	"foobg.png": 89383,
	"images/NS_logo.png": 78011,
	"images/SPIT_logo.png": 98774,
	"images/bg-input-focus.png": 44121,
	"images/bg-input.png": 24938,
	"images/dark.png": 87936,
	"images/data_science.jpg": 65355,
	"images/flags.png": 10075,
	"images/flags@2x.png": 93157,
	"images/foobg.png": 89383,
	"images/logo.png": 48801,
	"images/sort_asc.png": 39122,
	"images/sort_asc_disabled.png": 14135,
	"images/sort_both.png": 22140,
	"images/sort_desc.png": 22846,
	"images/sort_desc_disabled.png": 47107,
	"images/spit_colon.png": 41962,
	"images/spit_crohns.png": 37512,
	"images/spit_oes.png": 36800,
	"images/sprite.png": 28875,
	"images/ts_icon.png": 95271,
	"images/wink.png": 90781,
	"images/wink.svg": 19202,
	"images/wood.png": 17367,
	"logo.png": 48801,
	"sort_asc.png": 39122,
	"sort_asc_disabled.png": 14135,
	"sort_both.png": 22140,
	"sort_desc.png": 22846,
	"sort_desc_disabled.png": 47107,
	"spit_colon.png": 41962,
	"spit_crohns.png": 37512,
	"spit_oes.png": 36800,
	"sprite.png": 28875,
	"ts_icon.png": 95271,
	"wink.png": 90781,
	"wink.svg": 19202,
	"wood.png": 17367
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45587;